import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';

@Component({
  selector: 'app-modal-confirmation',
  standalone: true,
  imports: [ModalCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-confirmation.component.html',
})
export class ModalConfirmationComponent {
  imageUrl = input<string | null>(null);
  title = input.required<string>();
  highlightText = input<string | null>(null);
  subtitle = input<string | null>(null);
  countdownText = input<string | null>(null);
  buttonLabel = input<string | null>(null);
  buttonClick = output<void>();
}
